import request, { METHODS } from "src/utils/api-base";

const productApis = {
  createProduct: (payload: { page: number; limit: number }) => {
    return request({
      route: "/app/products/create",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },
  getProductList: (params: {
    page?: number;
    limit: number;
    status?: "active" | "inactive";
    search?: string;
  }) => {
    return request({
      route: "/app/products/list",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  // Edit product
  editProduct: (payload: any) => {
    return request({
      route: `/app/products/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },
};

export default productApis;
